import React, { useContext } from "react";
import CategoriesSection from "../components/homeComponents/CategoriesSection";
import banner from "../assets/ProductsBanner.png";
import ProductCard from "../components/homeComponents/ProductCard";
import { ProductContext } from "../Context/ProductContext";
import { useLocation } from "react-router-dom";
import NewLaunch from "../components/homeComponents/NewLaunch";
import FeaturedProducts from "../components/homeComponents/FeaturedProducts";
const CategoryProducts = () => {
  const { products } = useContext(ProductContext);
  const location = useLocation();
  const categoryId = location.state?.categoryId;
  const queryParams = new URLSearchParams(location.search);
  const categoryName = queryParams.get("category");
  
  // ✅ FILTER
const filteredProducts = categoryId
  ? products.filter(
      (item) =>
        String(item.category?._id) === String(categoryId)
    )
  : products;

  // ✅ GET CATEGORY NAME
  // const selectedCategoryName = filteredProducts[0]?.category?.name;
  return (
    <div>
      <img src={banner} alt="Banner" className="w-full" />

      <div className="py-10">
        
        <CategoriesSection />

        <div className="container mx-auto px-4 md:px-8">
          <h2 className="text-2xl lg:text-3xl font-semibold mb-8 mt-10">
            {categoryName || "All Products"}
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-6">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((item) => (
                <ProductCard key={item._id} item={item} /> 
              ))
            ) : (
              <p className="text-gray-500">
                No products found in this category.
              </p>
            )}
          </div>
        </div>
      <div className="container mx-auto">
        <NewLaunch 
          categoryName={categoryName} 
          isCategoryPage={true}
        />
        {/* <div className="container mx-auto px-8"> */}
        <FeaturedProducts 
          categoryName={categoryName} 
          isCategoryPage={true}
        />
        {/* </div> */}
      </div>
      </div>
    </div>
  );
};

export default CategoryProducts;